import React from 'react'
import { colors, H2 } from 'styling/GlobalStyles'

export const DashboardHeader = () => {
  return (
    <H2 noUpperCase>
      Operational Overview - role: <span style={{ color: colors.orange }}>Procurement Officer</span>
    </H2>
  )
}
